import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, isExpanded, onToggle, onCalculatorOpen }) => {
  const [selectedTech, setSelectedTech] = useState(null);

  return (
    <div className={`interactive-card p-6 transition-all duration-500 ${
      isExpanded ? 'col-span-full lg:col-span-2' : 'col-span-1'
    }`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`w-12 h-12 rounded-brand flex items-center justify-center ${service.bgColor}`}>
            <Icon name={service.icon} size={24} color="white" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-text-primary">{service.title}</h3>
            <p className="text-sm text-text-secondary">{service.subtitle}</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
          onClick={() => onToggle(service.id)}
          className="text-text-secondary hover:text-secondary"
        />
      </div>

      <p className="text-text-secondary mb-4">{service.description}</p>

      {/* Technology Stack */}
      <div className="flex flex-wrap gap-2 mb-4">
        {service.technologies.map((tech, index) => (
          <span
            key={index}
            onClick={() => setSelectedTech(tech)}
            className={`px-3 py-1 rounded-full text-xs font-medium cursor-pointer transition-brand ${
              selectedTech === tech
                ? 'bg-secondary text-white' :'bg-muted text-text-secondary hover:bg-secondary/10'
            }`}
          >
            {tech}
          </span>
        ))}
      </div>

      {/* Key Metrics */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="text-center p-3 bg-muted rounded-brand">
          <div className="text-lg font-bold text-secondary">{service.timeline}</div>
          <div className="text-xs text-text-secondary">Timeline</div>
        </div>
        <div className="text-center p-3 bg-muted rounded-brand">
          <div className="text-lg font-bold text-conversion-accent">{service.startingPrice}</div>
          <div className="text-xs text-text-secondary">Starting From</div>
        </div>
      </div>

      {/* Expanded Content */}
      {isExpanded && (
        <div className="mt-6 space-y-6 border-t border-border pt-6">
          {/* Methodology */}
          <div>
            <h4 className="text-lg font-semibold text-text-primary mb-3 flex items-center">
              <Icon name="GitBranch" size={18} className="mr-2 text-secondary" />
              Our Methodology
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
              {service.methodology.map((step, index) => (
                <div key={index} className="p-3 bg-muted rounded-brand">
                  <div className="text-sm font-medium text-text-primary">{step.phase}</div>
                  <div className="text-xs text-text-secondary mt-1">{step.description}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Success Metrics */}
          <div>
            <h4 className="text-lg font-semibold text-text-primary mb-3 flex items-center">
              <Icon name="TrendingUp" size={18} className="mr-2 text-success" />
              Success Metrics
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {service.metrics.map((metric, index) => (
                <div key={index} className="text-center p-4 bg-success/5 rounded-brand border border-success/20">
                  <div className="text-2xl font-bold text-success">{metric.value}</div>
                  <div className="text-sm text-text-secondary">{metric.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Interactive Demo */}
          {service.demoComponent && (
            <div>
              <h4 className="text-lg font-semibold text-text-primary mb-3 flex items-center">
                <Icon name="Play" size={18} className="mr-2 text-secondary" />
                Interactive Demo
              </h4>
              <div className="p-4 bg-muted rounded-brand">
                {service.demoComponent}
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="default"
              iconName="Calculator"
              iconPosition="left"
              onClick={() => onCalculate(service.id)}
              className="cta-primary"
            >
              Project Calculator
            </Button>
            <Button
              variant="outline"
              iconName="FileText"
              iconPosition="left"
            >
              View Case Studies
            </Button>
            <Button
              variant="ghost"
              iconName="MessageCircle"
              iconPosition="left"
            >
              Discuss Requirements
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceCard;